import * as React from 'react'
import { ErrorBoundary } from '@/modules/shared/components/ErrorBoundary'
import { ErrorFallback } from '@/modules/shared/components/ErrorFallback'
import { AppLayoutDahboardWithNav } from '@/modules/shared/layouts/AppLayoutDahboardWithNav'
import { PermissionGuard } from '@/modules/shared/components/NoPermission'
import { moduleAccess } from '@/modules/shared/permissions'
import { MySubscriptionPage } from './pages/MySubscriptionPage'
import { SubscriptionLayout } from './SubscriptionLayout'
import { useParams } from 'react-router-dom'
import { useUmbrellaAccount } from '@/modules/shared/hooks/useUmbrellaAccount'
import { UmbrellaBillingNotice } from '@/modules/shared/components/serviceAccount/UmbrellaBillingNotice'

const SubscriptionModuleImpl: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>()
  // Checked before the billing permission guard: a member without billing rights must
  // still learn which account bills this company instead of hitting "Brak uprawnień".
  const { umbrella, isLoading } = useUmbrellaAccount(companyId)
  return (
    <ErrorBoundary
      fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}
    >
      <AppLayoutDahboardWithNav>
        <ErrorBoundary
          fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}
        >
          {isLoading ? null : umbrella ? (
            <SubscriptionLayout>
              <UmbrellaBillingNotice companyId={companyId!} />
            </SubscriptionLayout>
          ) : (
            <PermissionGuard {...moduleAccess.subscription}>
              <SubscriptionLayout>
                <MySubscriptionPage />
              </SubscriptionLayout>
            </PermissionGuard>
          )}
        </ErrorBoundary>
      </AppLayoutDahboardWithNav>
    </ErrorBoundary>
  )
}

export const SubscriptionModule = SubscriptionModuleImpl
